<div class="auditoria-header">
  <div class="auditoria-header__accent"></div>
  <div class="container auditoria-header__inner">
    <span class="material-icons auditoria-header__icon">description</span>
    <div>
      <h1 class="auditoria-header__title">Detalle de auditoría</h1>
      <p class="auditoria-header__subtitle">Información completa del evento</p>
    </div>
  </div>
</div>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando auditoría...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="auditoria-area auditoria-animate-in">
  <div class="container">
    <div class="acciones-top">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver al listado
      </button>
    </div>

    <div class="no-data" *ngIf="!evento">
      No se encontró el registro solicitado.
    </div>

    <div class="detalle-card" *ngIf="evento">
      <p class="descripcion">{{ descripcion }}</p>

      <h3>Datos del evento</h3>
      <div class="grid-datos">
        <div class="dato"><span class="k">Acción</span><span class="v">{{ labelAccion(evento.accion) }}</span></div>
        <div class="dato"><span class="k">Módulo</span><span class="v">{{ labelModulo(evento.modulo) }}</span></div>
        <div class="dato"><span class="k">Pantalla</span><span class="v">{{ labelPantalla(evento.pantalla) }}</span></div>
        <div class="dato"><span class="k">Recurso</span><span class="v">{{ evento.recurso || '-' }}</span></div>
        <div class="dato"><span class="k">Ruta</span><span class="v">{{ evento.ruta || '-' }}</span></div>
        <div class="dato">
          <span class="k">Resultado</span>
          <span class="v">
            <span class="chip" [ngClass]="evento.resultado === 'ERROR' ? 'chip--error' : 'chip--ok'">
              {{ evento.resultado || 'EXITO' }}
            </span>
            <span *ngIf="evento.status"> ({{ evento.status }})</span>
          </span>
        </div>
        <div class="dato"><span class="k">Fecha</span><span class="v">{{ evento.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}</span></div>
      </div>

      <h3>Usuario</h3>
      <div class="grid-datos">
        <div class="dato"><span class="k">Nombre</span><span class="v">{{ evento.usuario?.nombreCompleto || '-' }}</span></div>
        <div class="dato"><span class="k">Email</span><span class="v">{{ evento.usuario?.email || '-' }}</span></div>
        <div class="dato"><span class="k">ID</span><span class="v">{{ evento.usuario?.id || '-' }}</span></div>
      </div>

      <h3>Origen</h3>
      <div class="grid-datos">
        <div class="dato"><span class="k">IP</span><span class="v">{{ evento.ip || '-' }}</span></div>
        <div class="dato dato--full"><span class="k">User Agent</span><span class="v">{{ evento.userAgent || '-' }}</span></div>
      </div>

      <h3 *ngIf="payloadEntries.length">Datos adicionales</h3>
      <div class="grid-datos" *ngIf="payloadEntries.length">
        <div class="dato" *ngFor="let item of payloadEntries">
          <span class="k">{{ item.clave }}</span>
          <span class="v">{{ item.valor }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
